import { Component, OnInit } from '@angular/core';
import { MapElement } from '../../shared/map/map-element.model';
import { Input } from '@angular/core';
import { GeometryObject } from 'geojson';
import { MarkerGeometry } from '~app/shared/map/map.service';

@Component({
  selector: 'qm-element-details',
  templateUrl: './element-details.component.html',
  styleUrls: ['./element-details.component.scss']
})
export class ElementDetailsComponent implements OnInit {
  /**
   * Current map object
   */
  @Input()
  public currentFeature: MapElement<MarkerGeometry>;

  constructor() { }

  ngOnInit() {
  }

}
